import { useEffect, useRef } from "react";
import { Marker, Popup } from "react-leaflet";
export default function CustomMarker({ 
    position, 
    icon,  
    isActive, 
    hash, 
    map, 
    history, 
    path1, 
    children,
}){
    //----------------------------------------------------------------------------------------
    let popupRef = useRef();
    //----------------------------------------------------------------------------------------
    useEffect(() => {
        map.whenReady(() => {
            if(isActive && popupRef.current && map){
                popupRef.current.setLatLng(position).openOn(map);
              }
          });
    }, [isActive, popupRef.current, map, position]);
    //----------------------------------------------------------------------------------------
    return (
        <Marker
            position = {position}
            icon = {icon}
            eventHandlers = {{
                popupopen: () => {
                    history.push(`/${path1}/${hash}`);
                },
                popupclose: () => {
                    const path = history.location.pathname;
                    const newPath1 = decodeURIComponent(path.split("/")[1] ?? "");
                    if(newPath1 === path1) history.push(`/${path1}`);
                }
            }}
        >
            <Popup ref = {popupRef} >
                {children}
            </Popup>
        </Marker>
    );
}